import {SerialStatusEnum} from "@/api/apiService";

export interface TableProduct {
  serialNumber: string;
  name: string;
  reference: string;
  photoUrl: string | null;
  status: SerialStatusEnum;
  purchaseDate: string;
  deletedAt: string | null;
  localizedCreationDate: string;
  countryCode: string | null;
  origin: string | null;
  locale: string | null;
}

export enum ConfirmTypes {
  DELETE_STATUS = 'delete-status',
  SEND_LINK = 'send-link',
  DISSOCIATE_PRODUCT = 'dissociate-product',
  VIEW_PRODUCT = 'view-product',
}

export interface CurrentConfirmation {
  serialId?: string;
  type?: ConfirmTypes;
}
